// Generated by scripts/mdi/import-questionnaires.mjs from MDI "2. Tirzepatide + B6 Refill 09.17.26" (4e44c743-6806-4d81-9f20-7d0b1cd4db93). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiTirzepatideB6RefillAnswerField } from './questions';

export const mdiTirzepatideB6Refill: FormType<mdiTirzepatideB6RefillAnswerField> =
  {
    name: 'Tirzepatide + B6 Refill',
    validityLength: 25,
    questions: [
      {
        key: 'mdiTirzepatideB6Refill_state',
        next: {
          switch: [
            {
              condition: { 'mdiTirzepatideB6Refill_state.la': true },
              key: 'mdiTirzepatideB6Refill_considerTreatmentGlp1AppropriateReasons'
            },
            {
              condition: { 'mdiTirzepatideB6Refill_state.ms': true },
              key: 'mdiTirzepatideB6Refill_considerTreatmentGlp1AppropriateReasons'
            }
          ],
          els: 'mdiTirzepatideB6Refill_overPast4WeeksApproximately'
        }
      },
      'mdiTirzepatideB6Refill_considerTreatmentGlp1AppropriateReasons',
      {
        key: 'mdiTirzepatideB6Refill_overPast4WeeksApproximately',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_overPast4WeeksApproximately.im_gaining_weight':
                  true
              },
              key: 'mdiTirzepatideB6Refill_stillGainingWeight'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_overPast4WeeksApproximately.more_than_20_pounds':
                  true
              },
              key: 'mdiTirzepatideB6Refill_youreHavingSignificantAmountWeight'
            }
          ],
          els: 'mdiTirzepatideB6Refill_havingFoodCravings'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_stillGainingWeight',
        next: {
          condition: {
            'mdiTirzepatideB6Refill_overPast4WeeksApproximately.more_than_20_pounds':
              true
          },
          key: 'mdiTirzepatideB6Refill_youreHavingSignificantAmountWeight',
          els: 'mdiTirzepatideB6Refill_havingFoodCravings'
        }
      },
      'mdiTirzepatideB6Refill_youreHavingSignificantAmountWeight',
      'mdiTirzepatideB6Refill_havingFoodCravings',
      'mdiTirzepatideB6Refill_havingAppetiteSuppression',
      {
        key: 'mdiTirzepatideB6Refill_newChangesAdditionsMedicalHistory',
        next: {
          condition: {
            'mdiTirzepatideB6Refill_newChangesAdditionsMedicalHistory.yes_i_do':
              true
          },
          key: 'mdiTirzepatideB6Refill_tellDoctorAboutNewMedical',
          els: 'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects'
        }
      },
      'mdiTirzepatideB6Refill_tellDoctorAboutNewMedical',
      'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects',
      {
        key: 'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.having_side_effects_but_i_can_handle_the':
                  true
              },
              key: 'mdiTirzepatideB6Refill_makeSureLetDoctorPcp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.significant_vomiting':
                  true
              },
              key: 'mdiTirzepatideB6Refill_vomitingWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.abdominal_pain_that_concerns_me':
                  true
              },
              key: 'mdiTirzepatideB6Refill_abdominalPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiTirzepatideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiTirzepatideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiTirzepatideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_makeSureLetDoctorPcp',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.significant_vomiting':
                  true
              },
              key: 'mdiTirzepatideB6Refill_vomitingWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.abdominal_pain_that_concerns_me':
                  true
              },
              key: 'mdiTirzepatideB6Refill_abdominalPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiTirzepatideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiTirzepatideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiTirzepatideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_vomitingWhileTakingGlp1',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.abdominal_pain_that_concerns_me':
                  true
              },
              key: 'mdiTirzepatideB6Refill_abdominalPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiTirzepatideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiTirzepatideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiTirzepatideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_abdominalPainWhileTakingGlp',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.dizziness_that_concerns_me':
                  true
              },
              key: 'mdiTirzepatideB6Refill_dizzinessWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiTirzepatideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiTirzepatideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_dizzinessWhileTakingGlp1',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.chest_pain':
                  true
              },
              key: 'mdiTirzepatideB6Refill_chestPainWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiTirzepatideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_chestPainWhileTakingGlp',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.fevers':
                  true
              },
              key: 'mdiTirzepatideB6Refill_feverWhileTakingGlp1'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_feverWhileTakingGlp1',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.swelling_in_my_neck':
                  true
              },
              key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_swellingNeckWhileTakingGlp',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_majorSideEffectsConcernedAbout.other':
                  true
              },
              key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_tellDoctorAboutSymptomsExperiencing',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_nausea':
                  true
              },
              key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_nauseaMostCommonSideEffect',
        next: {
          switch: [
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_constipation':
                  true
              },
              key: 'mdiTirzepatideB6Refill_constipation'
            },
            {
              condition: {
                'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
                  true
              },
              key: 'mdiTirzepatideB6Refill_heartburn'
            }
          ],
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      {
        key: 'mdiTirzepatideB6Refill_constipation',
        next: {
          condition: {
            'mdiTirzepatideB6Refill_havingProblemsCommonSideEffects.tell_me_more_about_indigestion_reflux':
              true
          },
          key: 'mdiTirzepatideB6Refill_heartburn',
          els: 'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment'
        }
      },
      'mdiTirzepatideB6Refill_heartburn',
      'mdiTirzepatideB6Refill_readInformationAboutPersonalizedTreatment',
      'mdiTirzepatideB6Refill_wereDiscontinueCompoundedTreatmentSignificantly',
      'mdiTirzepatideB6Refill_nextPrescriptionThinkShould',
      'mdiTirzepatideB6Refill_importantClickAttachedLinkReview',
      'mdiTirzepatideB6Refill_messageDoctorGiveUpdateFeel',
      'mdiTirzepatideB6Refill_complete'
    ]
  };
